import React from 'react';
import ReactDOM from 'react-dom';
import Homepage from './homepage/homepage';

document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("root");
  ReactDOM.render(<Homepage/>, root);
});



// WEBPACK FOOTER //
// ./lib/entry.jsx